import script from "./CustomerDashboardSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerDashboardSidebar.vue?vue&type=script&setup=true&lang=js"

import "./CustomerDashboardSidebar.vue?vue&type=style&index=0&id=8d51ab2c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d51ab2c"]])

export default __exports__